import type { Root } from "react-dom/client";
import { mountBusinessEngineApp } from "./frontend-app";

export function bootBusinessEngineFrontend(
  hotData: { root?: Root } | undefined = import.meta.hot?.data,
) {
  const elem = document.getElementById("root");
  if (!elem) {
    throw new Error('Root element "#root" not found');
  }
  mountBusinessEngineApp(elem, hotData);
}
